import DocumentsResourcesCollection from "./entity-collections/documents"
import CRMContactsResourcesCollection from "./entity-collections/crm-contacts"
import CRMAccountsResourcesCollection from "./entity-collections/crm-accounts"
import RemindersResourcesCollection from "./entity-collections/reminders"
import MeetingsResourcesCollection from "./entity-collections/meetings"
import EventsResourcesCollection from "./entity-collections/events"
import ProjectUpdatesResourcesCollection from "./entity-collections/project-updates"
import TaskUpdatesResourcesCollection from "./entity-collections/task-updates"
import GenericUpdatesResourcesCollection from "./entity-collections/generic-updates"
import TasksResourcesCollection from "./entity-collections/tasks"
import resourcesSessionLoader from "./session-loader"
import TimeReportsResourcesCollection from "./entity-collections/time-reports"
import TimeReport from "../model2/time-report/time-report"
import ProjectsResourcesCollection from "./entity-collections/projects"
import DependenciesResourcesCollection from "./entity-collections/dependencies"
import {resources_initSuccessorsPredecessors} from "./actions/init-successors-predecessors"
import ExpensesResourcesCollection from "./entity-collections/expenses"
import Expense from "../model2/expenses/expense/expense"
import {EntityType} from "../gd/const/item"
import ResourcesDeltaHandler from "./delta-handler/resources-delta-handler"
import RelevanceSettings from "../gd/manager/delta-handler/relevance-settings"
import {UpdateAction} from "../gd/manager/delta-handler/types"
import ModelEntity from "../model2/model-entity"
import resourcesProcessUpdates from "./delta-handler/process-updates"
import DebugPerformance from "../gd/utils/performance"
import Project from "../model2/project/project"
import Meeting from "../model2/meeting/meeting"
import Task from "../model2/task/task"
import TaskUpdate from "../../app/home/notifications/model/models/task/task-update"
import Document from "../model2/doc/document"
import Event from "../model2/event/event"
import {SessionMissingData} from "../gd-session/@type"
import {ProjectItem} from "../model2/project-item/project-item"

// const debug = "Resources"
const debug = false

export default class Resources {

    public tasks            : TasksResourcesCollection | null = null
    public taskUpdates      : TaskUpdatesResourcesCollection | null = null
    public genericUpdates   : GenericUpdatesResourcesCollection | null = null
    public projects         : ProjectsResourcesCollection | null = null
    public projectUpdates   : ProjectUpdatesResourcesCollection | null = null
    public events           : EventsResourcesCollection | null = null
    public meetings         : MeetingsResourcesCollection | null = null
    public reminders        : RemindersResourcesCollection | null = null
    public documents        : DocumentsResourcesCollection | null = null
    public crmAccounts      : CRMAccountsResourcesCollection | null = null
    public crmContacts      : CRMContactsResourcesCollection | null = null
    public timeReports      : TimeReportsResourcesCollection | null = null
    public dependencies     : DependenciesResourcesCollection | null = null
    public expenses         : ExpensesResourcesCollection | null = null

    // public todoItems        :

    public _ridMap                  : any   =  {}

    private deltaHandler?           : ResourcesDeltaHandler
    public deltaHandlerCallback?    : callback

    public relevanceSettings?       : RelevanceSettings

    constructor() {

    }

    public destroy() {
        gd.modelBus.unsubscribe(this)
        this.deltaHandler?.destructor()
    }



    getAllResources(collections:string[]): any[] {
        let res:any[] = []

        _.map(collections, (collectionName:string): void=>{
            // @ts-ignore
            if (this[collectionName]) res = res.concat(this[collectionName].models)
            else console.warn("Resources getAllResources: collection not found", collectionName)
        })

        return res
    }

    /** METHODS **/

    get(rid:RID):ModelEntity {
        return this._ridMap[rid]
    }

    // RESET collections

    resetTasks(data:JSONArray, options={}) {
        if (this.tasks) {
            this.tasks.reset(data, options)
        }
        else this.tasks = new TasksResourcesCollection(this, data, options)
    }

    // na samom dele tut ILI jsonarray ili array of models
    resetProjects(data:JSONArray, options={}) {
        if (this.projects) { this.projects.reset(data, options) }
        else this.projects = new ProjectsResourcesCollection(this, data, options)
    }

    resetEvents(data:JSONArray, options={}) {
        if (this.events) { this.events.reset(data, options) }
        else this.events = new EventsResourcesCollection(this, data, options)
    }

    resetReminders(data:JSONArray, options={})    {
        if (this.reminders) { this.reminders.reset(data, options) }
        else this.reminders = new RemindersResourcesCollection(this, data, options)
    }

    resetMeetings(data:JSONArray, options={})     {
        if (this.meetings) { this.meetings.reset(data, options) }
        else this.meetings = new MeetingsResourcesCollection(this, data, options)
    }

    resetContacts(data:JSONArray, options={})     {
        if (this.crmContacts) { this.crmContacts.reset(data, options) }
        else this.crmContacts = new CRMContactsResourcesCollection(this, data, options)
    }

    resetAccounts(data:JSONArray, options={})     {
        if (this.crmAccounts) { this.crmAccounts.reset(data, options) }
        else this.crmAccounts = new CRMAccountsResourcesCollection(this, data, options)
    }

    resetDocuments(data:JSONArray, options={})    {
        if (this.documents) { this.documents.reset(data, options) }
        else this.documents = new DocumentsResourcesCollection(this, data, options)
    }

    resetTaskUpdates(data:JSONArray,options={})              {
        if (this.taskUpdates) { this.taskUpdates.reset(data, options) }
        else this.taskUpdates = new TaskUpdatesResourcesCollection(this, data, options)
    }

    resetProjectUpdates(data:JSONArray,options={})           {
        if (this.projectUpdates) { this.projectUpdates.reset(data, options) }
        else this.projectUpdates = new ProjectUpdatesResourcesCollection(this, data, options)
    }

    resetGenericUpdates(data:JSONArray,options={})           {
        if (this.genericUpdates) {
            this.genericUpdates.reset(data, options)
        }
        else this.genericUpdates = new GenericUpdatesResourcesCollection(this, data, options)
    }

    // removes a notification update from whichever updates collection it belongs to
    removeUpdate(id:ID, entityType:EntityType) {
        switch (entityType) {
            case EntityType.UPDATE_TASK    : this.taskUpdates?.remove(id); break
            case EntityType.UPDATE_PROJECT : this.projectUpdates?.remove(id); break
            case EntityType.UPDATE_GENERIC : this.genericUpdates?.remove(id); break
        }
    }

    resetTimeReports(data:JSONArray, options:any={}) {
        if (this.timeReports) {
            this.timeReports.reset(data, options)
            // console.log("Time reports reset done lenght=", this.timeReports.length)
        }
        else {
            this.timeReports = new TimeReportsResourcesCollection(this, data, options)
        }
    }

    resetDependencies(data:JSONArray, options:any={}) {
        if (this.dependencies) { this.dependencies.reset(data, options) }
        else this.dependencies = new DependenciesResourcesCollection(this, data, options)
    }

    resetExpenses(data:JSONArray, options={}) {
        if (this.expenses) { this.expenses.reset(data, options) }
        else this.expenses = new ExpensesResourcesCollection(this, data, options)
    }

    // MISSING DATA
    async loadMissingData(options?:any):Promise<boolean> {

        // debug && DebugPerformance.start("Resources loadMissingData")
        //
        // return new Promise(async (resolve, reject) => {
        //
        //     const missingData = this.findMissingData(options)
        //     console.log(99, missingData)
        //     // const sessionLoaderPromise = resourcesSessionLoader(missingData)
        //     //
        //     // console.log(333, sessionLoaderPromise)
        //
        //     await resourcesSessionLoader(missingData)
        //
        //     console.log(99.1, "missing data loaded ")
        //
        //     // patch
        //     // if we have deleted(missing) company users we need recalculated costs in time reports
        //     console.log(100)
        //     if (missingData && missingData.companyUsers) {
        //         console.log(101)
        //         this.tasks?.resetTimeReports()
        //     }
        //     // end
        //
        //     debug && DebugPerformance.stop("Resources loadMissingData")
        //
        //
        //     resolve(true)
        // })

        const missingData = this.findMissingData(options)
        const sessionLoaderPromise = await resourcesSessionLoader(missingData)

        // patch
        // if we have deleted(missing) company users we need recalculated costs
        if (missingData && missingData.companyUsers) {
            this.tasks?.resetCostFields()
        }
        // end

        return sessionLoaderPromise
    }

    public findMissingData(options?: any):SessionMissingData|false {
        debug && DebugPerformance.start("findMissingData collect")

        // Use Sets for deduplication and O(1) lookup
        const allUsers                  : Set<ID> = new Set()  // I think were not using it as gd.users always has all users, but from now we will need it as we need companyUser (even if deleted for calculation of ht ecosts)
        const allTaskTypes              : Set<ID> = new Set()
        const allStatuses               : Set<ID> = new Set()
        const allProjects               : Set<ID> = new Set()
        const allProjectsWithParents    : Set<ID> = new Set()
        const allNoteTypes              : Set<ID> = new Set()
        const allCustomFields           : Set<ID> = new Set()
        const allExpenseCategories      : Set<ID> = new Set()

        // Helper to add array or value to set
        const addToSet = (set: Set<ID>, value: ID | ID[] | null | undefined) => {
            if (Array.isArray(value)) {
                value.forEach(v => v && set.add(v))
            } else if (value !== undefined && value !== null) {
                set.add(value)
            }
        }

        if (this.tasks) {
            const searchProjectsWithParents = _.get(options, 'taskProjectWithParents', false)
            for (const task of this.tasks.models as Task[]) {
                addToSet(allTaskTypes, task.taskTypeId)
                addToSet(allStatuses, task.statusId)

                if (searchProjectsWithParents) {
                    addToSet(allProjectsWithParents, task.projectId)
                    _.map(task.projects, (projectItem: ProjectItem) => {
                        addToSet(allProjectsWithParents, projectItem.projectId)
                    })
                } else {
                    addToSet(allProjects, task.projectId)
                    _.map(task.projects, (projectItem: ProjectItem) => {
                        addToSet(allProjects, projectItem.projectId)
                    })
                }

                if (task.tags) {
                    addToSet(allProjects, task.tags)
                }

                // customFieldsData is an object with keys as custom field ids
                if (task.customFieldsData) {
                    Object.keys(task.customFieldsData).forEach(prop => allCustomFields.add(prop));
                }

                // Add custom fields from taskType
                const taskType = gd.session.taskTypes.get(task.taskTypeId)
                if (taskType && Array.isArray(taskType.customFields)) {
                    addToSet(allCustomFields, taskType.customFields)
                }


                // New - for time reports
                addToSet(allUsers, task.timeReports.userIds)
                // if (task.timeReports && !task.timeReports.isEmpty) {
                //     if (task.timeReports.userIds) {
                //         addToSet(allUsers, task.timeReports.userIds)
                //     } else {
                //         console.warn("#sjjd2928 no time reports userIds found - strange - might me an issues")
                //     }
                // }

            }
        }

        if (this.taskUpdates) {
            for (const taskUpdate of this.taskUpdates.models as TaskUpdate[]) {
                const { fromUserId, toUserId, taskStatusId } = taskUpdate.taskMessage || {}
                addToSet(allUsers, fromUserId)
                addToSet(allUsers, toUserId)
                addToSet(allStatuses, taskStatusId)
            }
        }

        // debug && console.log(debug, 'findMissingData projects', this.projects?.models)
        debug && DebugPerformance.start("findMissingData projects")
        const projects: ID[] = []
        if (this.projects) {
            for (const project of this.projects.models as Project[]) {
                addToSet(allStatuses, project.statusId)
                // addToSet(allUsers, project.ownerUserId) // it is really slow and ownerUserId is never missing (projects are reassigned on company user delete)

                if (Array.isArray(project.users)) {
                    for (const user of project.users) {
                        addToSet(allUsers, user.userId)
                    }
                }

                // customFieldsData is an object with keys as custom field ids
                if (project.customFieldsData) {
                    Object.keys(project.customFieldsData).forEach(prop => allCustomFields.add(prop))
                }

                addToSet(allTaskTypes, project.taskTypes)
                addToSet(allProjects, project.id)

                projects.push(project.id)
            }
        }
        debug && DebugPerformance.stop("findMissingData projects")

        debug && DebugPerformance.start("findMissingData involvedProjects")
        const involvedProjectsIds: ID[] = _.uniq(gd.session.projects.getAllInvolvedProjectsIds(projects))
        // debug && console.log(debug, 'findMissingData involvedProjects', involvedProjectsIds)
        for (const pId of involvedProjectsIds) {
            const project = gd.session.projects.get(pId)
            if (project && project.localTemplateId) {
                addToSet(allCustomFields, project.customFields)
                addToSet(allProjects, project.localTemplateId)
            }
        }
        debug && DebugPerformance.stop("findMissingData involvedProjects")

        if (this.expenses) {
            for (const expense of this.expenses.models as Expense[]) {
                addToSet(allProjects, expense.projectId)
                addToSet(allUsers, expense.userId)
                addToSet(allExpenseCategories, expense.expenseCategoryId)
            }
        }

        if (this.documents) {
            for (const document of this.documents.models as Document[]) {
                addToSet(allProjects, document.projectId)
                addToSet(allUsers, document.editors)
                addToSet(allNoteTypes, document.noteTypeId)
            }
        }

        if (this.timeReports) {
            for (const timeReport of this.timeReports.models as TimeReport[]) {
                addToSet(allUsers, timeReport.userId)
            }
        }

        if (this.events) {
            for (const event of this.events.models as Event[]) {
                addToSet(allProjects, event.projectId)
                addToSet(allUsers, event.assignedToUserId)
                addToSet(allUsers, event.userId)
            }
        }

        if (this.meetings) {
            // meetings follow the same option as tasks: a caller that needs the project
            // hierarchy (reports) needs it for meeting projects too
            const meetingProjects = _.get(options, 'taskProjectWithParents', false)
                ? allProjectsWithParents
                : allProjects

            for (const meeting of this.meetings.models as Meeting[]) {
                if (meeting.projectId) addToSet(meetingProjects, meeting.projectId)
                if (meeting.users?.models) {
                    for (const user of meeting.users.models) {
                        addToSet(allUsers, user.userId)
                    }
                }
            }
        }

        debug && DebugPerformance.stop("findMissingData collect")

        return gd.session.findMissing({
            users               : Array.from(allUsers),
            companyUsers        : Array.from(allUsers),
            taskTypes           : Array.from(allTaskTypes),
            statuses            : Array.from(allStatuses),
            projects            : Array.from(allProjects),
            noteTypes           : Array.from(allNoteTypes),
            projectsWithParents : Array.from(allProjectsWithParents),
            customFields        : Array.from(allCustomFields),
            expenseCategories   : Array.from(allExpenseCategories)
        })
    }

    // this method set successors and predecesors fields based on dependencies
    public initSuccessorsPredecessors() {
        resources_initSuccessorsPredecessors(this)
    }


    // Delta & Session sync

    public subscribeToSessionEvents(entities: EntityType[], callback:callback) {

        debug && console.log(debug, "subscribeToSessionEvents()")

        // destroy if exists & kill all model bus subscriptions
        if (this.deltaHandler) {
            this.deltaHandler.destructor()
        }

        this.deltaHandler           = new ResourcesDeltaHandler(this, entities)
        this.deltaHandlerCallback   = callback
    }


    processUpdates(updates:(false|undefined|UpdateAction)[]) {
        resourcesProcessUpdates(this, updates)
    }


}
